import _ from "lodash";
import React from "react";

const ModalForm = React.createClass({
    getInitialState: function() {
        return { mounted: false };
    },
    componentDidMount: function() {
        this.setState({ mounted: true });
    },
    propTypes: {
        title: React.PropTypes.string,
        size: React.PropTypes.string,
        raw_body: React.PropTypes.bool,
        children: React.PropTypes.node
    },
    render() {
        var title = this.props.title;
        var body = this.props.children;
        var is_small = (this.props.size == "small");
        var is_large = (this.props.size == "large");
        var raw_body = !!this.props.raw_body;
        var onClose = _.isFunction(this.props.onClose) ? this.props.onClose : undefined;
        if (!raw_body) {
            body = <div className="modal-body">{body}</div>;
        }

        return (
            <div className={"modal-dialog" + (is_large ? " modal-lg" : "") + (is_small ? " modal-sm" : "")} role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={onClose}>
                            <i className="fa fa-times"></i>
                        </button>
                        <h4 className="modal-title">
                            {title}
                        </h4>
                    </div>
                    {body}
                </div>
            </div>
        );
    }
});

export default ModalForm;


// WEBPACK FOOTER //
// ./src/components/widgets/ModalForm.js